<div class="hb-container hb-container--width-lg">
  <div class="hb-grid hb-mb--xl">
    <div class="hb-cell hb-cell--12of12">
      <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Åpne data fra Husbanken</h1>

      <hb-accordion class="hb-mb--lg hb-cell hb-cell--10of12@lg">
        <hb-accordion-element id="dataID">
          <h2 title class="hb-accordion-tittel">Om data fra Husbanken</h2>
          <div body="">
            <p>Datasettene følger Norsk lisens for offentlige data (NLOD). Det er ikke nødvendig å registrere seg for å ta datasettet i bruk. Tjenesten er gratis. </p>
            @if (kpi) {
              <p>
                <strong>Lisens: </strong>
                <a href="https://data.norge.no/nlod/no/1.0" target="_blank" class="hb-button hb-button--link">
                  <span class="hb-button-text">Norsk lisens for offentlige data</span>
                  <span class="hb-icon hb-icon--size100" aria-hidden="true">
                  <svg focusable="false">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/sprite.symbol.svg#icon-expand-6"></use>
                  </svg>
                </span>
                </a> <br/>
                <strong>Publisert: </strong>{{ kpi.value.qText }}<br/>
                <strong>Oppdateres: </strong>Daglig<br/>
                <strong>Språk: </strong>Norsk<br/>
                <strong>Tidsperiode: </strong>Fra 2008 – til dagens dato<br/>
                <strong>Geografi: </strong>Norge<br/>
                <strong>Husbankens kontaktpunkt: </strong> <a href="mailto:statistikkgruppa@husbanken.no" class="hb-button hb-button--link">statistikkgruppa&#64;husbanken.no</a>
              </p>
            }
            <p><strong>Relevante lenker</strong> <br/>
              <a href="https://husbanken.no/" target="_blank" class="hb-button hb-button--link">
                <span class="hb-button-text">Husbanken.no</span>
                <span class="hb-icon hb-icon--size100" aria-hidden="true">
                  <svg focusable="false">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/sprite.symbol.svg#icon-expand-6"></use>
                  </svg>
                </span>
              </a><br/>
              <a href="https://data.norge.no/data/registerenheten-i-brønnøysund/enhetsregisteret" class="hb-button hb-button--link" target="_blank">
                <span class="hb-button-text">Enhetsregisteret</span>
                <span class="hb-icon hb-icon--size100" aria-hidden="true">
                  <svg focusable="false">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/sprite.symbol.svg#icon-expand-6"></use>
                  </svg>
                </span></a><br/>
            </p>
          </div>
        </hb-accordion-element>
      </hb-accordion>

      <div class="hb-cell hb-cell--10of12@lg hb-avstand--gruppe">
        <hb-callout tone="INFO">
          <p>Datasett for Husbankens boligsosiale virkemidler inneholder saksdetaljer fra 2008 og frem til i dag. </p>
          <p>Innholdet oppdateres hver natt. Datasett som lastes ned på to ulike tidspunkt vil derfor kunne inneholde ulik informasjon om en sak.
            Dersom det har skjedd endringer på en sak så vil saken fremkomme med statusen på nedlastningstidspunktet. </p>
          <p>Statistikkbanken fremstiller endringer på det tidspunktet de skjedde, mens de åpne datasettene fremstiller saken på nedlastningstidspunktet. I tillegg er forretningslogikken for rapportering bygd inn i Statistikkbanken.
            Det vil derfor kunne forekomme avvik dersom man forsøker å gjenskape rapporttall fra Statistikkbanken ved hjelp av de åpne datasettene.</p>
        </hb-callout>
      </div>

      <div class="hb-komposisjon">
        @for (datasetConfig of datasets; track datasetConfig) {
          <div class="hb-komposisjon-element hb-cell--10of12">
            <stat-downloaddatasett [title]="datasetConfig.title"
                                 [rader]="datasetConfig.rader"
                                 [omDataGrunnlaget]="datasetConfig.omDataGrunnlaget"
                                 [dokumentasjon]="'http://biblioteket.husbanken.no/arkiv/dok/Statistikk/Dokumentasjon/Dokumentasjon_nedlastbare_datasett.xlsx'"
            ></stat-downloaddatasett>
          </div>
        }
      </div>

      <div class="hb-cell hb-cell--10of12@lg">
        <hb-callout tone="WARNING">
          <p>Vi ønsker å forbedre og videreutvikle tjenesten for åpne data, og tar gjerne imot innspill. Du kan sende inn innspill til <a href="mailto:statistikkgruppa@husbanken.no">statistikkgruppa&#64;husbanken.no</a></p>
        </hb-callout>
      </div>


    </div>
  </div>
</div>
